import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/images/80eight/88-footer-white.svg";
import Toaster from "./ui/toaster";
import bgVideo from "../assets/images/loader.mp4";

export default function CardSpinningLoader({ logoTopposition = "top-[80%]" }) {
  return (
    <AnimatePresence>
      <div className="relative h-full min-h-[240px] w-full">
        <motion.div
          className="absolute inset-0 z-40 flex items-center justify-center bg-white dark:bg-black"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
        >
          <div className="relative flex h-full w-full max-h-full scale-150 items-center justify-center lg:h-[70%] lg:w-[70%] lg:scale-100">
            <video
              src={bgVideo}
              autoPlay
              loop
              muted
              playsInline
              className="absolute inset-0 h-full w-full object-contain"
            />
          </div>
        </motion.div>
        <motion.img
          src={logo}
          alt=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className={`pointer-events-none absolute left-1/2 z-50 h-12 w-auto max-w-[min(280px,90vw)] -translate-x-1/2 ${logoTopposition}`}
        />
      </div>
      <Toaster />
    </AnimatePresence>
  );
}
